import React from 'react'
import * as styles from './index.module.css'

const CustomerQuote = ({ subtitle }) => {
  const subtitleFrags = subtitle.subtitle.split('\n')

  return (
    <div className={styles.container}>
      <div className={styles.quote}>{subtitleFrags[0]}</div>
      <div className={styles.authorContainer}>
        <div className={styles.author}>
          {`- ${subtitleFrags[1].replace('-', '')}`}
        </div>
        <div className={styles.companyName}>{subtitleFrags[2]}</div>
      </div>
    </div>
  )
}

export default CustomerQuote
